import ControlConsultant from './controlConsultant';
import ControlClinician from './controlClinician';
import React from 'react';
import {getConfig} from '../../../util/configUtil';

function ControlConsultantComponent(props) {
    const consultantComponentEnabled = getConfig('consultantComponentEnabled', false);
    if (consultantComponentEnabled) {
        return <ControlConsultant {...props} />;
    } else {
        return <ControlClinician {...props} />;
    }
}

export default ControlConsultantComponent;